import type {
  CategoryCreateInput,
  CategoryUpdateInput,
} from "@/modules/categories/domain/contracts";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type CategoryDTO = {
  id: string;
  parentId: string | null;
  name: string;
  createdAt: string;
};

export type CategoriesListResult = {
  data: CategoryDTO[];
  meta: { total: number; limit: number; offset: number };
};

export const categoriesApi = {
  async list(query: OffsetPageQueryDTO) {
    const url = new URL(`${config.apiUrl}/categories`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<CategoriesListResult>(url.toString());
  },

  async get(id: string) {
    return fetcher.get<CategoryDTO>(`${config.apiUrl}/categories/${id}`);
  },

  async create(input: CategoryCreateInput) {
    return fetcher.post<CategoryDTO>(`${config.apiUrl}/categories`, input);
  },

  async update(id: string, input: CategoryUpdateInput) {
    return fetcher.patch<CategoryDTO>(
      `${config.apiUrl}/categories/${id}`,
      input,
    );
  },

  async remove(id: string) {
    return fetcher.delete<{ ok: boolean }>(`${config.apiUrl}/categories/${id}`);
  },
};
